import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "LiquidityGAPGlobal" })((_theme) => ({
  page: {
    margin: "20px",
  },
  liquidityGAPGlobalExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
